export default {
  username: "Username",
  password: "Password",
  btnLogin: "Login",
  forgotpass: "Forgot Password",
  createAccount: "Register Now",
  currentPwd: "Current Password",
  newPwd: "New Password",
  currentPwd: "Current Password",
  confirmPwd: "Confirm Password",
  resetPwd: "Reset Password",
  changePwd: "Change Password",
  changePwdInfo: "Change Password Information",
  proceedBtn: "Proceed",
  continueBtn: "Continue",
  confirmEmail: "Confirm Email",
  goToLogin: "Back to Login",
  logout: "Log out",
  fldWithAsteRq: "Fields with ( * ) are required",
  isRequired: " is required",
  home: "Dashboard",
  //CASA PRODUCT
  CASAProducts: "CASA Products",
  AddCASAProducts: "New CASA Product",
  ViewCASAProducts: "View CASA Product",
  CASADetailView: "CASA detail",
  EditCASAProducts: "Edit CASA Product",
  CASAProduct: "CASA Product",
  newCasaCreatedMsg: "CASA Product was created sucessfully.",
  editCasaCreatedMsg: "Casa Product was successfully updated",
  productName: "Product Name",
  shortName: "Short Name",
  decimalPlaces: "Decimal Places",
  multiplesOf: "Multiples Of",
  norminalAnnualInterest: "Nominal Annual Interest(%)",
  interestCompoundingPeriod: "Interest Compounding Period",
  interestPostingPeriod: "Interest Posting Period",
  interestCalculatedUsing: "Interest Calculated Using",
  daysInYear: "Days In Year",
  minimumOpeningBalance: "Minimum Opening Balance",
  lockInPeriod: "Lock-in Period",
  applyWithdrawalFeeForTransfers: "Apply Withdrawal Fee for Transfers",
  applyDepositFeeForTransfers: "Apply Deposit fee for transfers	",
  allowOverdraft: "Allow Overdraft",
  allowLien: "Allow Lien",
  maxOverdraftLimit: "Max Overdraft limit",
  nominalAnnualInterestForOverdraft: " Nominal Annual Interest For Overdraft",
  minOverdraftRequiredForInterestCalculation:
    "Min Overdraft Required For Interest Calculation",

  balanceRequiredForInterestCalculation:
    "Balance Required For Interest Calculation",
  enforceMinimumBalance: "Enforce Minimum Balance",
  minimumBalance: "Minimum Balance",
  iswithholdTaxApplicable: "Is Withhold Tax Applicable?",
  isDormancyTrackingActive: "Is Dormancy Tracking Active?",
  numberOfDaysToInactiveSubStatus: "Number of Days to Inactive Sub-status",
  numberOfDaysToDormantSubStatus: "Number of Days to Dormant Sub-status",
  numberOfDaysToEscheat: "Number of Days to Escheat",
  casaReference: "CASA Reference",
  depositReference: "Deposit Reference",
  // casaReference: "CASA Reference (Assets)",
  overdraftPortfolio: "Overdraft Portfolio",
  // overdraftPortfolio: "Overdraft Portfolio (Assets)",
  casaControl: "CASA Control",
  depositControl: "Deposit Control",
  // casaControl: "CASA Control (Liabilities)",
  transfersInSupense: "Transfers In Suspense",
  // transfersInSupense: "Transfers In Suspense (Liabilities)",
  escheatLiability: "Escheat Liability",
  // escheatLiability: "Escheat Liability (Liabilities)",
  interestOnCasa: "Interest on CASA",
  interestOnDeposit: "Interest on Deposit",
  // interestOnCasa: "Interest on CASA (Expenses)",
  writeOff: "Write-off",
  // writeOff: "Write-off (Expenses)",
  comissions: "Commissions",
  // comissions: "Commissions (Expenses)",
  incomeFromFee: "Income From Fees",
  // incomeFromFee: "Income From Fees (Income)",
  incomeFromPenalties: "Income From Penalties",
  // incomeFromPenalties: "Income From Penalties (Income)",
  overderaftInterestIncome: "Overdraft Interest Income",
  // overderaftInterestIncome: "Overdraft Interest Income (Income)",
  charge: "Charge",
  charges: "Charges",

  // Customer
  manageCustomer: "Manage Customer",
  generalLedger: "General Ledger",
  moduleSample: "Module Sample",
  newGLAccount: "New GL Account",
  newSubLedgerAccount: "New SubLedger Account",
  generalInfo: "General Information",
  home: "Dashboard",
  accountType: "Account Type",
  parent: "Parent",
  GLCode: "GL Code",
  accountName: "Account Name",
  accountUsage: "Account Usage",
  tag: "Tag",
  manualEntriesAllowed: "Manual Entries Allowed?",
  status: "Status",
  currency: "Currency",
  description: "Description",
  newGLCreatedMsg: "GL Account was successfully created",
  editGLCreatedMsg: "GL Account was successfully updated",
  gLApproveRejectedMsg: "GL Account was successfully updated",
  newJournalEntryMsg: "New Journal Entry was successfully created",
  deleteGlAccountMsg: "GL Account was successfully Closed",
  description: "Description",
  glDetail: "General Ledger Detail",
  glDetailView: "GL Detail",
  glDetail: "General Ledger Detail",
  editGLAccount: "Edit GL Account",
  recordStatus: "Record Status",
  authStatus: "Auth Status",
  makerId: "Maker ID",
  makerDate: "Maker Date",
  checkerId: "Checker ID",
  checkerDate: "Checker Date",
  pleaseSelect: "Select",
  pleaseEnter: "Enter",
  description: "Description",
  // JOURNAL ENTRY
  journalEntries: "Journal Entries",
  journalEntry: "View Journal Entry",
  newJournalEntry: "New Journal Entry",
  searchJournalEntry: "Search Journal Entry",
  viewJournalEntryDetail: "Journal Entry Detail",
  journalEntrySetup: "Journal Entry Setup",
  transactionNumber: "Transaction Number",
  journalEntryList: "Journal Entry List",
  debit: "Debit",
  debits: "Debits",
  credit: "Credit",
  credits: "Credits",
  branch: "Branch",
  entryId: "Entry ID",
  transactionId: "Transaction ID",
  transactionDate: "Transaction date",
  type: "Type",
  account: "Account",
  paymentDetails: "Payment Details",
  paymentType: "Payment Type",
  createdBy: "Created by",
  createdOn: "Created on",
  additionalInfo: "Additional Information",
  amountToBeReserved: "Amount to be Reserved",
  office: "Office",
  currency: "Currency",
  affectedGLEntries: "Affected GL Entries",
  referenceNumber: "Reference Number",
  transactionDate: "Transaction Date",
  comments: "Comments",
  glAccountId: "glAccountId",
  amount: "Amount",
  paymentTypes: "Payment Types",
  accountNumber: "Account Number",
  chequeNumber: "Cheque Number",
  routingCode: "Routing Code",
  receiptNumber: "Receipt Number",
  bank: "Bank",
  filter: "Filter",
  category: "Category",
  dateRange: "Date Range",

  // GL MAPPING
  GLMapping: "General Ledger Mapping",
  newGLMapping: "New GL Mapping",
  GLMappingdetail: "GL Mapping detail",
  GLMappingDetailBreadcrumbs: "GL Mapping detail",
  editGLMapping: "Edit GL Mapping",
  EditGLMappingBreadcrumbs: "Edit GL Mapping",
  editGLMappingMsg: "GL Mapping was successfully updated",
  deleteGLMappingMsg: "GL Mapping was successfully closed",
  financialActivity: "Financial Activity",
  account: "Account",

  // ACCOUNTING RULES

  AccountingRules: "Accounting Rules",
  newAccountingRules: "New Accounting Rule",
  AccountingRulesDetail: "Accounting Rule Detail",
  editAccountingRules: "Edit Accounting Rule",
  deleteAccoutingRuleMsg: "Accounting Rule was successfully deleted",
  newAccountingRuleMsg: "Accounting Rule was successfully created",
  EditAccountingRuleBreadcrumbs: "Edit Accounting Rule",
  EditAccountingRuleMsg: "Accounting Rule was successfully updated",
  accountingRuleName: "Accounting Rule Name",
  accountingRuleOffice: "Office",
  accountingRuleDescription: "Description",
  debitRuleType: "Debit Rule Type",
  creditRuleType: "Credit Rule Type",
  AllowMultipleDebitEntries: "Allow Multiple Debit Entries",
  AllowMultipleCreditEntries: "Allow Multiple Credit Entries",

  // FINANCE RULES
  financeRules: "Finance Rules",
  newFinanceRules: "New Finance Rule",
  viewFinanceRuleDetail: "Finance Rule Detail",
  editFinanceRules: "Edit Finance Rule",
  financeRuleSetup: "Finance Rule Setup",
  currencyInfo: "Currency Information",
  plInfo: "PL Account Information",
  glAccountOptions: "GL Account Options",
  newFinanceRuleCreatedMsg: "Finance Rule was successfully created",
  editFinanceRuleCreatedMsg: "Finance Rule was successfully updated",
  deleteFinanceRuleMsg: "Finance Rule was successfully deleted",
  finPeriodStart: "Financial Period Start",
  finPeriodEnd: "Financial Period End",
  finYearEnd: "Financial Year End",
  localCurrency: "Local Currency",
  revaluationOptions: "Revaluation Options",
  automaticRevaluation: "Automatic Revaluation",
  manualRevaluation: "Manual Revaluation",
  comMonthlyGlBalance: "Compute Monthly Average GL Balance",
  reportLargeMovement: "Report Large Movement",
  movementValue: "Minimum Large Movement Value",
  allowReversalAcrossPeriod: "Allow Reversal Across Period",
  allowReversalAcrossFinYear: "Allow Reversal Across Financial Year",
  pLAccountProfitGL: "PL Account Profit GL",
  pLAccountLossGL: "PL Account Loss GL",
  print: "Print",
  csv: "CSV",
  exportCSV: "Export CSV",

  // FUND SOURCE
  FundSource: "Fund Source",
  newFundSource: "New Fund Source",
  newFundSourceCreatedMsg: "Fund Source was successfully created",
  FundSourcedetail: "Funds Source Detail",
  editFundSource: "Edit Fund Source",
  editFundSourceMsg: "Fund Source was successfully updated",

  // END OF CIRCLES - ACCOUNT CLOSURE
  accountClosure: "Account Closure",
  newAccountClosure: "New Account Closure",
  viewAccountClosureDetail: "Account Closure Detail",
  deleteAccountClosure: "Edit Account Closure",
  accountClosureSetup: "Account Closure Setup",
  branch: "Branch",
  closingDate: "Closing Date",
  deleteEndOfCircleMsg: "Account Closure was successfully deleted",
  newEndOfCircleCreatedMsg: "Account Closure was successfully created",
  closureDate: "Closure Date",
  closedBy: "Closed By",
  updateBy: "Update By",
  updateOn: "Updated On",
  closureCreationDate: "Closure Creation Date",
  // PERIODIC ACCRUAL
  periodicAccrual: "Periodic Accrual",
  peridicAccrualsInfo: "Execute Periodic Accrual Accounting",
  periodicAccrualExecuted: "Periodic Accrual successfully executed",
  deleteFundSourceMsg: "Fund Source was successfully deleted",

  // FREQUENT POSTING
  FrequentPosting: "Frequent Posting",
  newFrequentPostingMsg: "Frequent Posting was successfully retrieved",
  viewFrequentPosting: "View Frequent Posting",

  // LOAN PRODUCT
  LoanProduct: "Loan Product",
  newLoanProduct: "New Loan Product",
  LoanProductDetail: "Loan Product Detail",
  newLoanProductMsg: "Loan Product was successfully created",
  editLoanProductMsg: "Loan Product was successfully updated",
  editLoanProduct: "Edit Loan Product",
  sysErrorMsg: "Sys-Error 20011 - Admin Has Been Notified",

  // FIXED DEPOSIT
  FixedDeposit: "Fixed Deposit",
  newFixedDeposit: "New Fixed Deposit",
  newFixedDepositMsg: "Fixed Deposit was successfully created",
  editFixedDepositMsg: "Fixed Deposit was successfully edited",
  FixedDepositDetail: "Fixed Deposit Detail",
  editFixedDeposit: "Edit Fixed Deposit",
  productSetup: "Product Setup",

  // PROVISIONING ENTRIES
  provisioningEntries: "Provisioning Entries",
  newProvisioningEntries: "New Provisioning Entries",
  viewProvisioningEntriesDetail: "Provisioning Entries Detail",
  provisioningEntriesSetup: "Provisioning Entries Setup",
  provisioningCriteria: "Provisioning Criteria",
  createJournalEntries: "Create Journal Entries",
  // deleteAccountClosure: "Edit Account Closure",
  deleteProvisioningEntriesMsg: "Provisioning Entries was successfully deleted",
  newProvisioningEntriesMsg: "Provisioning Entry was successfully created",

  // Fund Mapping
  adHocQuerySearchForLoans: "AdHoc Query Search For Loans",
  advanceSearch: "Advance Search",
  selectDateType: "Select Date Type",
  between: "Between",
  loan: "Loan",
  loanStatus: "Loan Status",
  productInfo: "Product Information",
  loanInfo: "Loan Information",
  all: "All",
  active: "Active",
  overPaid: "Overpaid",
  closedObligationsMet: "Closed (obligations met)",
  closedWrittenOff: " Closed (written-off)",
  loanOutstandingPercentage: "Loan Outstanding Percentage",
  loanOutstandingAmount: "Loan Outstanding Amount",
  approvalDate: "Approve Date",
  creationDate: "Creation Date",
  disbursementDate: "Disbursement Date",
  // RECURRING DEPOSIT PRODUCT
  RecurringDepositProducts: "Recurring Deposit Products",
  AddRecurringDepositProduct: "New Recurring Deposit Product",
  ViewRecurringDepositProduct: "View Recurring Deposit Product",
  RecurringDepositProductDetailView: "Recurring Deposit detail",
  EditRecurringDepositProduct: "Edit Recurring Deposit Product",
  RecurringDepositProduct: "Recurring Deposit Product",
  newRecurringDepositCreatedMsg:
    "Recurring Deposit Product was successfully created",
  editRecurringDepositCreatedMsg:
    "Recurring Deposit Product was successfully updated",
  productName: "Product Name",
  shortName: "Short Name",
  decimalPlaces: "Decimal Places",
  multiplesOf: "Multiples Of",
  norminalAnnualInterest: "Nominal Annual Interest(%)",
  interestCompoundingPeriod: "Interest Compounding Period",
  interestPostingPeriod: "Interest Posting Period",
  interestCalculatedUsing: "Interest Calculated Using",
  daysInYear: "Days In Year",
  minimumOpeningBalance: "Minimum Opening Balance",
  lockInPeriod: "Lock-in Period",
  applyWithdrawalFeeForTransfers: "Apply Withdrawal Fee for Transfers",
  applyDepositFeeForTransfers: "Apply Deposit Fee for Transfers	",
  allowOverdraft: "Allow Overdraft",
  maxOverdraftLimit: "Max Overdraft limit",
  nominalAnnualInterestForOverdraft: " Nominal Annual Interest For Overdraft",
  minOverdraftRequired: "Min Overdraft Required",
  forInterestCalculation: "For Interest Calculation",
  balanceRequiredForInterestCalculation:
    "Balance Required For Interest Calculation",
  enforceMinimumBalance: "Enforce Minimum Balance",
  minimumBalance: "Minimum Balance",
  iswithholdTaxApplicable: "Is Withhold Tax Applicable?",
  isDormancyTrackingActive: "Is Dormancy Tracking Active?",
  numberOfDaysToInactiveSubStatus: "Number of Days to Inactive Sub-status",
  numberOfDaysToDormantSubStatus: "Number of Days to Dormant Sub-status",
  numberOfDaysToEscheat: "Number of Days to Escheat",
  charge: "Charge",
  charges: "Charges",
  editRecurringDepositProduct: "Edit Recurring Deposit Product",
  editRecurringDepositProductMsg:
    "Recurring Deposit Product was successfully edited",

  // FX RATE SETUP
  fxRateSetup: "FX Rate Setup",
  newFxRateSetup: "New FX Rate Setup",
  fxRateSetupDetail: "GL Mapping detail",
  internetConnection:
    "Could not connect to the server. Please check your network",
  smthWentWrong:
    "We were unable to obtain timely feedback on your request. Please retry.",

  // MANAGE USERS
  manageUsers: "Manage Users",
  newUser: "New User",
  manageUsersDetail: "User Details",
  editUsersDetail: "Edit User",
  EditManageUsersMsg: "User was successfully updated",
  editManageUsersBreadcrumbs: "Edit User",
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email",
  manageUsersAutoGeneratePassword: "Auto Generate Password",
  manageUsersOverridePassword: "Override Password Expiry Policy?",
  manageUsersOffice: "Office",
  manageUsersRoles: "Roles",
  manageUsersStaff: "Staff",
  newUserMsg: "New User was successfully created",
  password: "Password",
  confirmPassword: "Confirm Password",


  undoTransactionMsg:"Reverse Action Successful",

  //  CASA to GL Transfers 
  addCASAToGlTransfer:"CASA To GL Transfer",
  addGlToCASATransfer:"GL To CASA Transfer"
};